
import { defineComponent } from 'vue';
import Modal from '@/components/modals/Modal.vue';
import AgencyCreateForm from '@/components/agency/AgencyCreateForm.vue';

export default defineComponent({
  name: 'agency-create-modal',
  emits: ['update:modelValue', 'formSubmitted', 'close'],
  props: {
    modelValue: { type: Boolean, default: false },
  },
  components: {
    Modal,
    AgencyCreateForm,
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    handleDataSubmitted() {
      this.$emit('formSubmitted');
    },

    handleClose() {
      this.$emit('close');
    },
  },
});
